// EXTERNAL DEPENDENCIES
import React from 'react'

// COMPONENTS
import {
  Col,
  Container,
  Panel,
  PanelSlider,
  ProgressStepper,
  Step,
} from '@paypalcorp/pp-react'

// TEST IDS
import { PANEL_SLIDER_WITH_PROGRESS_STEPPERS_TEST_ID } from '@/constants/test-ids'

// STYLES
import styles from './styles.module.less'

// TYPES
import { Panel as PanelProps } from '@/screens/create-profile-page/types'
type PanelSliderWithProgressSteppersProps = {
  handleSubmit?: () => void
  currentPanelIndex: number
  panels: PanelProps[]
  isLoading?: boolean
}

/**
 * @description Displays given panels with Progress Steppers
 */
const PanelSliderWithProgressSteppers: React.FC<
  PanelSliderWithProgressSteppersProps
> = ({ handleSubmit, currentPanelIndex, isLoading, panels }) => {
  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    handleSubmit?.()
  }

  const everyPanelHasAStepTitle = panels.every((panel) => panel.stepTitle)

  return (
    <Col
      className={styles.panelSliderContainer}
      data-testid={PANEL_SLIDER_WITH_PROGRESS_STEPPERS_TEST_ID}
    >
      {everyPanelHasAStepTitle && !isLoading ? (
        <ProgressStepper className={styles.progressStepperContainer}>
          {panels.map((panel, panelIndex) => (
            <Step
              isNumeric
              key={panelIndex + 1}
              title={panel.stepTitle}
              status={currentPanelIndex > panelIndex ? 'success' : 'default'}
              isCurrent={currentPanelIndex === panelIndex}
            />
          ))}
        </ProgressStepper>
      ) : null}
      <form onSubmit={onSubmit} className={styles.formContainer}>
        <PanelSlider
          easing='cubic-bezier(0, 0.9, 0.3, 1)'
          panelId={currentPanelIndex}
        >
          <Container form>
            <Panel
              key={'' + currentPanelIndex}
              className={styles.panelContainer}
            >
              {panels[currentPanelIndex]?.panel}
            </Panel>
          </Container>
        </PanelSlider>
      </form>
    </Col>
  )
}

export default PanelSliderWithProgressSteppers
